import { get, post } from "../../utils/httpClient";

const importFileService = () => {
  const prefixApi = "duedates";

  const getImportBatch = async (id) => {
    return await get(`/${prefixApi}/importbatches/${id}`);
  };

  const getTasksExcelTemplate = async () => {
    return await get(`/${prefixApi}/tasks/import/template`, null, {
      responseType: "blob",
    });
  };

  const getTaskTemplateExcelTemplate = async () => {
    return await get(`/${prefixApi}/tasktemplates/import/template`, null, {
      responseType: "blob",
    });
  };

  const importTasks = async ({ boardId, file }) => {
    const formData = new FormData();
    formData.append("ExcelFile", file[0].rawFile);
    formData.append("BoardId", boardId);

    return await post(`${prefixApi}/tasks/import`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const importTemplates = async ({ taskTypeId, file }) => {
    const formData = new FormData();
    formData.append("ExcelFile", file[0].rawFile);
    formData.append("TaskTypeId", taskTypeId);

    return await post(`${prefixApi}/tasktemplates/import`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  return {
    getImportBatch,
    getTasksExcelTemplate,
    getTaskTemplateExcelTemplate,
    importTasks,
    importTemplates,
  };
};

export default importFileService;
